'use client';
/** @jsxImportSource @emotion/react */

import { type FC } from 'react';

import type { PopperProps as MuiPopperProps } from '@mui/material/Popper';

import MuiPopper from '@mui/material/Popper';

/**
 * Omitting the component prop from Popper ensures consistent positioning and prevents layout issues caused by unsupported or incompatible elements.
 * It simplifies maintenance and avoids unexpected behavior, making the component more reliable and easier to use.
 * And the default implementation in MUI is also broken, and altering it could lead to issues.
 *
 * https://serko.atlassian.net/browse/ZDS-1034
 */
type ExcludedMuiProps = 'component';

/**
 * @deprecated Please use `Popover` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-popover-migration--popover-migration-guide Migration guide}
 */
export type PopperProps = Omit<MuiPopperProps, ExcludedMuiProps>;

/**
 * @deprecated Please use `Popover` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-popover-migration--popover-migration-guide Migration guide}
 */
export const Popper: FC<PopperProps> = MuiPopper;

Popper.displayName = 'Popper';
